import { queryOptions } from '@tanstack/react-query';
import { apiFetch } from '../api-client';

export interface TeamMember {
  id: string;
  email: string;
  role: 'admin' | 'support' | 'read_only';
  ssoIdentity?: string;
  createdAt: string;
}

async function fetchTeam(): Promise<TeamMember[]> {
  const res = await apiFetch('/api/console/team');
  if (!res.ok) throw new Error('Failed to load team');
  const json = await res.json();
  return json.members;
}

export function teamQueryOptions() {
  return queryOptions({
    queryKey: ['team'],
    queryFn: fetchTeam,
  });
}
